export const ENDPOINT = {
  MEALS_RECIPES: 'https://www.themealdb.com/api/json/v1/1/search.php?s=',
  DRINKS_RECIPES: 'https://www.thecocktaildb.com/api/json/v1/1/search.php?s=',

  MEALS_BY_INGREDIENT: 'https://www.themealdb.com/api/json/v1/1/filter.php?i=',
  DRINKS_BY_INGREDIENT: 'https://www.thecocktaildb.com/api/json/v1/1/filter.php?i=',

  MEALS_BY_FIRST_LETTER: 'https://www.themealdb.com/api/json/v1/1/search.php?f=',
  DRINKS_BY_FIRST_LETTER: 'https://www.thecocktaildb.com/api/json/v1/1/search.php?f=',

  MEALS_CATEGORIES: 'https://www.themealdb.com/api/json/v1/1/list.php?c=list',
  DRINKS_CATEGORIES: 'https://www.thecocktaildb.com/api/json/v1/1/list.php?c=list',

  MEALS_BY_CATEGORY: 'https://www.themealdb.com/api/json/v1/1/filter.php?c=',
  DRINKS_BY_CATEGORY: 'https://www.thecocktaildb.com/api/json/v1/1/filter.php?c=',

  MEAL_DETAILS: 'https://www.themealdb.com/api/json/v1/1/lookup.php?i=',
  DRINK_DETAILS: 'https://www.thecocktaildb.com/api/json/v1/1/lookup.php?i=',
};

export const empty = '';
